'use client';

import { c as _c } from "react/compiler-runtime";
import { BasicTooltip } from '@/comps/basic-tooltip';
import { cn } from '@/utils/shad';

/** Same wrapping tooltip panel the applied-filter chips use for their truncated labels. */
const CHIP_NAME_TOOLTIP_CLASS = 'max-w-sm break-normal! text-wrap wrap-break-word text-start';
type ChipNameProps = {
  name: string;
  className?: string;
};

/**
 * Team and segment names run long, so chips cap the name and hand the full string to a tooltip
 * rather than growing to fit it.
 */
export function ChipName(t0) {
  const $ = _c(8);
  const {
    name,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("max-w-36 truncate", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== name || $[3] !== t1) {
    t2 = <span className={t1}>{name}</span>;
    $[2] = name;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== name || $[6] !== t2) {
    t3 = <BasicTooltip text={name} classNameContent={CHIP_NAME_TOOLTIP_CLASS}>{t2}</BasicTooltip>;
    $[5] = name;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}